import { useEffect, useState } from "react";
import moment from "moment";
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Select,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  CircularProgress,
  Tab,
  Tabs,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
} from "@mui/material";
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import MyPagination from "src/components/common/MyPagination";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";
import { asyncRequest } from "src/services/network";
import { alert } from "src/services/alert";
import StringUtil from "src/utils/StringUtil";
import UserInfo from "src/components/common/UserInfo";
import { XFQ_RECORD_TYPE_MAP, XFQ_RECORD_TYPES } from "src/config/constants";

const types = Object.values(XFQ_RECORD_TYPES);

const LIST_TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "user", label: "用户", alignRight: false },
  { id: "amount", label: "变动数额", alignRight: false },
  { id: "current", label: "当前剩余", alignRight: false },
  { id: "detail", label: "详情", alignRight: false },
  { id: "relation", label: "关联订单", alignRight: false },
  { id: "isMer", label: "类型", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
];

const STATS_TABLE_HEAD = [
  { id: "user", label: "用户", alignRight: false },
  { id: "recordCount", label: "记录数", alignRight: false },
  { id: "totalAmount", label: "合计变动", alignRight: false },
  { id: "lastCurrent", label: "最后余额", alignRight: false },
  { id: "firstDate", label: "最早日期", alignRight: false },
  { id: "lastDate", label: "最新日期", alignRight: false },
  { id: "action", label: "操作", alignRight: false },
];

const DETAIL_STATS_TABLE_HEAD = [
  { id: "detail", label: "详情类型", alignRight: false },
  { id: "recordCount", label: "记录数", alignRight: false },
  { id: "totalAmount", label: "合计变动", alignRight: false },
];

export default function XfqV2Bak0302() {
  const [tabIndex, setTabIndex] = useState(0);

  // ---- 列表 Tab ----
  const [listItems, setListItems] = useState(null);
  const [listTotal, setListTotal] = useState(0);
  const [listLoading, setListLoading] = useState(false);
  const [listFilter, setListFilter] = useState({
    page: 0,
    size: 20,
    uid: "",
    type: -1,
    isMer: "",
    orderSN: "",
    createdAt: null,
  });

  // ---- 用户统计 Tab ----
  const [statsItems, setStatsItems] = useState(null);
  const [statsTotal, setStatsTotal] = useState(0);
  const [statsLoading, setStatsLoading] = useState(false);
  const [statsFilter, setStatsFilter] = useState({
    page: 0,
    size: 20,
    uid: "",
    type: -1,
    isMer: "",
    createdAt: null,
  });

  // ---- 用户详情统计弹窗 ----
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [detailDialogUid, setDetailDialogUid] = useState(null);
  const [detailDialogUser, setDetailDialogUser] = useState(null);
  const [detailItems, setDetailItems] = useState(null);
  const [detailTotalAmount, setDetailTotalAmount] = useState(0);
  const [detailTotalCount, setDetailTotalCount] = useState(0);

  async function loadList(overrideFilter) {
    const params = overrideFilter && overrideFilter.uid !== undefined ? overrideFilter : listFilter;
    if (!params.uid) {
      alert("请输入用户ID", "warning");
      return;
    }
    setListLoading(true);
    setListItems(null);
    const { data, count } = await asyncRequest({
      path: "/finance/xfq-v2-bak0302/list",
      data: params,
    });
    setListItems(data);
    setListTotal(count);
    setListLoading(false);
  }

  async function loadStats(overrideFilter) {
    const params = overrideFilter && overrideFilter.uid !== undefined ? overrideFilter : statsFilter;
    if (!params.uid) {
      alert("请输入用户ID", "warning");
      return;
    }
    setStatsLoading(true);
    setStatsItems(null);
    const { data, count } = await asyncRequest({
      path: "/finance/xfq-v2-bak0302/user-stats",
      data: params,
    });
    setStatsItems(data);
    setStatsTotal(count);
    setStatsLoading(false);
  }

  async function loadDetailStats(uid, user) {
    setDetailDialogUid(uid);
    setDetailDialogUser(user);
    setDetailItems(null);
    setDetailDialogOpen(true);
    const res = await asyncRequest({
      path: "/finance/xfq-v2-bak0302/detail-stats",
      data: { uid, isMer: statsFilter.isMer || undefined, createdAt: statsFilter.createdAt || undefined },
    });
    setDetailItems(res.data);
    setDetailTotalAmount(res.totalAmount);
    setDetailTotalCount(res.totalCount);
  }

  function handleTabChange(_, newVal) {
    setTabIndex(newVal);
  }

  const isListNotFound = listItems && listItems.length === 0;
  const isStatsNotFound = statsItems && statsItems.length === 0;

  return (
    <Page title="消费券备份记录(0302)">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            消费券备份记录（0302快照）
          </Typography>
        </Stack>

        <Card>
          <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3, pt: 1 }}>
            <Tabs value={tabIndex} onChange={handleTabChange}>
              <Tab label="明细列表" />
              <Tab label="用户统计" />
            </Tabs>
          </Box>

          {/* ===== 明细列表 Tab ===== */}
          {tabIndex === 0 && (
            <>
              <ListToolbar
                showSearch={false}
                onSearch={loadList}
                onReset={() => {
                  setListItems(null);
                  setListFilter({ page: 0, size: 20, uid: "", type: -1, isMer: "", orderSN: "", createdAt: null });
                }}
              >
                <Grid container rowGap={2} alignItems="center">
                  <Grid item lg={6} sm={6} md={3}>
                    <MyDateRangePicker
                      value={listFilter.createdAt}
                      onChange={(val) => setListFilter({ ...listFilter, createdAt: val, page: 0 })}
                    />
                  </Grid>
                  <Grid item sm={6} md={3}>
                    <TextField
                      size="small"
                      style={{ width: 200 }}
                      label="用户ID"
                      placeholder="用户ID（必填）"
                      autoComplete="off"
                      value={listFilter.uid}
                      onChange={(e) => setListFilter({ ...listFilter, uid: e.target.value, page: 0 })}
                    />
                  </Grid>
                  <Grid item sm={6} md={3}>
                    <TextField
                      size="small"
                      style={{ width: 200 }}
                      label="订单号"
                      placeholder="订单号"
                      autoComplete="off"
                      value={listFilter.orderSN}
                      onChange={(e) => setListFilter({ ...listFilter, orderSN: e.target.value, page: 0 })}
                    />
                  </Grid>
                  <Grid item sm={6} md={3}>
                    <FormControl size="small">
                      <InputLabel>类型</InputLabel>
                      <Select
                        label="类型"
                        value={listFilter.type}
                        onChange={(e) => setListFilter({ ...listFilter, type: e.target.value, page: 0 })}
                        style={{ width: 180 }}
                      >
                        <MenuItem value={-1}>全部</MenuItem>
                        {types.map((t) => (
                          <MenuItem key={t} value={t}>
                            {XFQ_RECORD_TYPE_MAP[t] || t}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={6} md={3}>
                    <FormControl size="small">
                      <InputLabel>用户/商家</InputLabel>
                      <Select
                        label="用户/商家"
                        value={listFilter.isMer}
                        onChange={(e) => setListFilter({ ...listFilter, isMer: e.target.value, page: 0 })}
                        style={{ width: 150 }}
                      >
                        <MenuItem value="">全部</MenuItem>
                        <MenuItem value={0}>用户</MenuItem>
                        <MenuItem value={1}>商家</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </ListToolbar>

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <ListHead headLabel={LIST_TABLE_HEAD} />
                    {listLoading ? (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={8}>
                            <Stack sx={{ width: "100%", height: 200 }} alignItems="center" justifyContent="center">
                              <CircularProgress />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : !listItems ? (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={8}>
                            <Stack sx={{ width: "100%", height: 200 }} alignItems="center" justifyContent="center">
                              <Typography color="text.secondary">请输入用户ID并点击查询</Typography>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody>
                        {listItems.map((row) => {
                          const { id, user, uid, relation, amount, current, createdAt, isMer, detail } = row;
                          return (
                            <TableRow hover key={id} tabIndex={-1}>
                              <TableCell align="left">{id}</TableCell>
                              <TableCell align="left">
                                {user ? <UserInfo {...user} enablePreview /> : `UID: ${uid}`}
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  color={parseFloat(amount) >= 0 ? "success.main" : "error.main"}
                                  variant="body2"
                                >
                                  {StringUtil.trimZero(amount)}
                                </Typography>
                              </TableCell>
                              <TableCell align="left">{StringUtil.trimZero(current)}</TableCell>
                              <TableCell align="left">{detail}</TableCell>
                              <TableCell align="left">{relation}</TableCell>
                              <TableCell align="left">
                                <Chip
                                  size="small"
                                  label={isMer ? "商家" : "用户"}
                                  color={isMer ? "warning" : "default"}
                                />
                              </TableCell>
                              <TableCell align="left">
                                {moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    )}
                    {isListNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={8} sx={{ py: 5 }}>
                            <SearchNotFound />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
              <MyPagination
                total={listTotal}
                page={listFilter.page}
                size={listFilter.size}
                onChange={(_, v, newSize) => {
                                const newFilter = newSize !== undefined
                                  ? { ...listFilter, page: 0, size: newSize }
                                  : { ...listFilter, page: v - 1 };
                                setListFilter(newFilter);
                                loadList(newFilter);
                              }}
              />
            </>
          )}

          {/* ===== 用户统计 Tab ===== */}
          {tabIndex === 1 && (
            <>
              <ListToolbar
                showSearch={false}
                onSearch={loadStats}
                onReset={() => {
                  setStatsItems(null);
                  setStatsFilter({ page: 0, size: 20, uid: "", type: -1, isMer: "", createdAt: null });
                }}
              >
                <Grid container rowGap={2} alignItems="center">
                  <Grid item lg={6} sm={6} md={3}>
                    <MyDateRangePicker
                      value={statsFilter.createdAt}
                      onChange={(val) => setStatsFilter({ ...statsFilter, createdAt: val, page: 0 })}
                    />
                  </Grid>
                  <Grid item sm={6} md={3}>
                    <TextField
                      size="small"
                      style={{ width: 200 }}
                      label="用户ID"
                      placeholder="用户ID（必填）"
                      autoComplete="off"
                      value={statsFilter.uid}
                      onChange={(e) => setStatsFilter({ ...statsFilter, uid: e.target.value, page: 0 })}
                    />
                  </Grid>
                  <Grid item sm={6} md={3}>
                    <FormControl size="small">
                      <InputLabel>用户/商家</InputLabel>
                      <Select
                        label="用户/商家"
                        value={statsFilter.isMer}
                        onChange={(e) => setStatsFilter({ ...statsFilter, isMer: e.target.value, page: 0 })}
                        style={{ width: 150 }}
                      >
                        <MenuItem value="">全部</MenuItem>
                        <MenuItem value={0}>用户</MenuItem>
                        <MenuItem value={1}>商家</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </ListToolbar>

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <ListHead headLabel={STATS_TABLE_HEAD} />
                    {statsLoading ? (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={7}>
                            <Stack sx={{ width: "100%", height: 200 }} alignItems="center" justifyContent="center">
                              <CircularProgress />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : !statsItems ? (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={7}>
                            <Stack sx={{ width: "100%", height: 200 }} alignItems="center" justifyContent="center">
                              <Typography color="text.secondary">请输入用户ID并点击查询</Typography>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody>
                        {statsItems.map((row) => {
                          const { uid, user, recordCount, totalAmount, lastCurrent, firstDate, lastDate } =
                            row.dataValues || row;
                          return (
                            <TableRow hover key={uid} tabIndex={-1}>
                              <TableCell align="left">
                                {user ? <UserInfo {...user} enablePreview /> : `UID: ${uid}`}
                              </TableCell>
                              <TableCell align="left">{recordCount}</TableCell>
                              <TableCell align="left">
                                <Typography
                                  color={parseFloat(totalAmount) >= 0 ? "success.main" : "error.main"}
                                  variant="body2"
                                >
                                  {StringUtil.trimZero(totalAmount)}
                                </Typography>
                              </TableCell>
                              <TableCell align="left">{StringUtil.trimZero(lastCurrent)}</TableCell>
                              <TableCell align="left">{firstDate}</TableCell>
                              <TableCell align="left">{lastDate}</TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="body2"
                                  sx={{ cursor: "pointer", color: "primary.main", textDecoration: "underline" }}
                                  onClick={() => loadDetailStats(uid, user)}
                                >
                                  查看详情
                                </Typography>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    )}
                    {isStatsNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={7} sx={{ py: 5 }}>
                            <SearchNotFound />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
              <MyPagination
                total={statsTotal}
                page={statsFilter.page}
                size={statsFilter.size}
                onChange={(_, v, newSize) => {
                                const newFilter = newSize !== undefined
                                  ? { ...statsFilter, page: 0, size: newSize }
                                  : { ...statsFilter, page: v - 1 };
                                setStatsFilter(newFilter);
                                loadStats(newFilter);
                              }}
              />
            </>
          )}
        </Card>
      </Container>

      {/* ===== 用户 detail 统计弹窗 ===== */}
      <Dialog open={detailDialogOpen} onClose={() => setDetailDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          {detailDialogUser
            ? `用户 ${detailDialogUser.nickname || detailDialogUser.mobile || ""} (UID: ${detailDialogUid}) - 明细分类统计`
            : `UID: ${detailDialogUid} - 明细分类统计`}
        </DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={3} mb={2}>
            <Typography variant="body2">合计记录数：{detailTotalCount}</Typography>
            <Typography variant="body2">合计变动金额：{detailTotalAmount}</Typography>
          </Stack>
          {!detailItems ? (
            <Stack alignItems="center" justifyContent="center" sx={{ height: 150 }}>
              <CircularProgress />
            </Stack>
          ) : (
            <TableContainer>
              <Table size="small">
                <ListHead headLabel={DETAIL_STATS_TABLE_HEAD} />
                <TableBody>
                  {detailItems.map((row, idx) => {
                    const { detail, recordCount, totalAmount } = row.dataValues || row;
                    return (
                      <TableRow hover key={idx}>
                        <TableCell>{detail || "-"}</TableCell>
                        <TableCell>{recordCount}</TableCell>
                        <TableCell>
                          <Typography
                            color={parseFloat(totalAmount) >= 0 ? "success.main" : "error.main"}
                            variant="body2"
                          >
                            {StringUtil.trimZero(totalAmount)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>
    </Page>
  );
}
